// extracted by mini-css-extract-plugin
export var editButton = "_mt-0";